<template>
  <Navbar></Navbar>
  <div class="product-detail-page">
    <div class="detail-banner">
      <div class="img-box detail-banner-img"><img src="/assets/product/engine/4D20M/4D20M.jpg" alt=""></div>
      <div class="detail-banner-r">
        
        <div class="detail-banner-t2">4D20M 2.0T Diesel Engine</div>
        <div class="detail-banner-desc">
          New Generation 2.0T High-Performance, Low-Fuel-Consumption Diesel Engine.
        </div>
      </div>
    </div>
  </div>

  <div class="detail-box">
    <div class="detail-title">High Power</div>
    <div class="detail-desc">Achieves lower starting RPM, greater torque output, and an expanded continuous RPM range for smoother acceleration and instantaneous power delivery, elevating your driving experience.</div>
    <div class="detail-utils">
      <div class="detail-utils-item">
        <div class="detail-utils-d">Maximum Power</div>
        <div class="detail-utils-u">120kW 3600r/min</div>
      </div>
      <div class="detail-utils-item">
        <div class="detail-utils-d">Maximum Torque</div>
        <div class="detail-utils-u">400N·m 1400~2600r/min</div>
      </div>
      <div class="detail-utils-item">
        <div class="detail-utils-d">Enhanced Low-End Torque</div>
        <div class="detail-utils-u">1000r/min 210N·m，1200r/min 300N·m</div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box">
      <div class="img-box detail-swiper-right ">
        <img src="/assets/product/engine/4D20M/4D20M-1.jpg" alt=""></img>
      </div>
      <div class="detail-swiper-left">
        <div>
          <div class="detail-title">
            High-Efficiency Electrically Controlled VGT Turbocharger
          </div>
          <div class="detail-desc">
            Significantly improved turbocharger efficiency enhances launch response, acceleration power, and fuel economy.
          </div>
        </div>
        <div class="detail-swiper-utils">
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              210N·m
            </div>
            <div class="detail-swiper-d">
              Low-Speed Power Performance（1000r/min）
            </div>
          </div>
        </div>
      </div>
      
    </div>
  </div>

  <div class="detail-box">
    <div class="detail-title">Low Fuel Consumption & Emissions</div>
    <div class="detail-desc">Features a bowl-shaped combustion chamber, high-efficiency spiral tangential intake ports, and a 2000bar high-pressure common rail system. Multiple friction-reduction and loss-mitigation measures ensure more complete combustion and lower fuel consumption.</div>
    
    
    

    <div class="detail-four-list">
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D20M/4D20M-3.jpg" alt=""></img>
        </div>
      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          The High-Pressure Common Rail System
        </div>
        <div class="detail-four-desc">
          With 2000bar system pressure and high-speed electromagnetic fuel injectors, it significantly improves fuel atomization and ensures more complete combustion.
        </div>
      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          High-Pressure EGR System
        </div>
        <div class="detail-four-desc">
          With high-pressure EGR technology, it reduced engine pumping losses and NOx emissions, enhancing overall vehicle fuel economy.
        </div>
      </div>
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D20M/4D20M-4.jpg" alt=""></img>
        </div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box">
      
      <div class="detail-swiper-left">
        <div>
          <div class="detail-title">
            Optimized Intake System
          </div>
          <div class="detail-desc">
            Incorporates spiral tangential intake ports and adds guide shielding structures at the cylinder head intake ports to optimize airflow shape, improve flow field intensity, increase air utilization efficiency, and significantly enhance fuel economy. 
          </div>
        </div>
        <div class="detail-swiper-utils">
          <div class="detail-swiper-util-item">
            <div class="detail-swiper-n">
              60%
            </div>
            <div class="detail-swiper-d">
              Swirl ratio increased
            </div>
          </div>
        </div>
      </div>
      
      <div class="img-box detail-swiper-right ">
        <img src="/assets/product/engine/4D20M/4D20M-2.jpg" alt=""></img>
      </div>
    </div>

  </div>


  <div class="detail-box">
    <div class="detail-title">NVH</div>
    <div class="detail-desc">Delivers NVH performance comparable to gasoline engines, with development focused on creating the quietest diesel engine through both active and passive noise reduction measures.</div>
    <div class="detail-four-list">
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D20M/4D20M-5.jpg" alt=""></img>
        </div>
      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          Camshaft Parallel Configuration with Backlash Elimination Gears
        </div>
        <div class="detail-four-desc">
          By employing backlash elimination gears and optimally matching the torsional spring stiffness of the secondary gears, gear vibration is reduced by 74% while optimizing camshaft torsional vibration amplitude, resolving two typical NVH issues (gear rattle and whine), reducing engine gear rattle noise by 5dBA.
        </div>

      </div>
      <div class="detail-four-item">
        <div class="detail-four-title">
          Optimized Timing System Design
        </div>
        <div class="detail-four-desc">
          Proper phase alignment between the timing belt and pulleys reduces belt tension and improves meshing noise. Compared to chain systems, the belt system generates lower noise levels. Combined with an upper plastic and lower cast aluminum timing cover, it provides excellent shielding against both high- and low-frequency noise on the timing side.
        </div>

      </div>
      <div class="detail-four-item">
        <div class="img-box">
          <img src="/assets/product/engine/4D20M/4D20M-6.jpg" alt=""></img>
        </div>
      </div>
    </div>

    <div class="detail-swiper-list detail-box">
      <div class="img-box detail-swiper-right ">
        <img src="/assets/product/engine/4D20M/4D20M-7.jpg" alt=""></img>
      </div>
      <div class="detail-swiper-left">
        <div>
          <div class="detail-title">
            Integrated Bottom-Mounted Balance Shaft
          </div>
          <div class="detail-desc">
            Enhances overall vehicle NVH comfort with an added balance shaft configuration, positioning the drive gear at the front of the crankshaft to reduce torsional vibration excitation and minimize gear rattle noise, resulting in a measured reduction of over 5dBA in engine bottom radiation noise. 
          </div>
        </div>

      </div>
    </div>

  </div>


  <Footer></Footer>
</template>

<script setup>
import { ref, nextTick, onMounted } from 'vue';
import Navbar from '@/components/Navbar.vue';
import Footer from '@/components/Footer.vue';
import Swiper from 'swiper/bundle';
import 'swiper/swiper-bundle.css';
const swiperInstances = ref({});

onMounted(() => {
  nextTick(() => {
    const swiperContainers = document.querySelectorAll('.swiper-container');

    swiperContainers.forEach((container, index) => {
      const containerKey = `swiper_${index}`;
      container.dataset.swiperKey = containerKey;
      const swiperInstance = new Swiper(container, {
        loop: false,
        slidesPerView: 1,
        spaceBetween: 0,
        speed: 300,
        preventClicks: true,
        effect: 'fade',
      });
      swiperInstances.value[containerKey] = swiperInstance;
    });

    bindTabClickEvent();
  });
});
function bindTabClickEvent() {
  const allSwiperLists = document.querySelectorAll('.detail-swiper-list');

  allSwiperLists.forEach((swiperList) => {
    const tabItems = swiperList.querySelectorAll('.detail-tab-item');
    const targetSwiperContainer = swiperList.querySelector('.swiper-container');

    if (!tabItems.length || !targetSwiperContainer) return;

    const containerKey = targetSwiperContainer.dataset.swiperKey;
    const targetSwiper = swiperInstances.value[containerKey];
    if (!targetSwiper) return;

    const handleTabAction = (tabItem, localTabIndex) => {
      tabItems.forEach(item => item.classList.remove('active'));
      tabItem.classList.add('active');
      targetSwiper.slideTo(localTabIndex, 300, true);
    };
    tabItems.forEach((tabItem, localTabIndex) => {
      const handleTabClickWrapper = () => {
        handleTabAction(tabItem, localTabIndex);
      };
      tabItem.removeEventListener('click', handleTabClickWrapper);
      tabItem.removeEventListener('mouseenter', handleTabClickWrapper);
      tabItem.addEventListener('click', handleTabClickWrapper);
      tabItem.addEventListener('mouseenter', handleTabClickWrapper);
    });
  });
}

</script>

<script>
export const pageConfig = {
  title: '44D20M 2.0T Diesel Engine - FINEST Website',
  keywords: 'FINEST,Engine,Transmission,Electronics',
  description: 'FINEST Automotive Technology Group Co., Ltd.An auto parts enterprise with core technologies of power system from traditional power to hybrid power and then to pure electric power (including inverters) and automotive intelligent integrated system.FINEST has a complete software and hardware industry chain Provide customers with efficient, energy-saving and environmentally friendly automotive power system and Intelligent driving solutions.',
  outputPath: 'en/engine/4D20M.html'
};

import { createApp } from 'vue';
import App from './4D20M.vue';
import store from '@/store/index';
import "@/assets/styles/global.scss"
import "@/assets/styles/product-details.scss"

function mountApp() {
  const appNode = document.getElementById('app');
  if (appNode) {
    if (appNode._vueApp) {
      appNode._vueApp.unmount();
      delete appNode._vueApp;
    }
    const app = createApp(App);
    app.use(store);
    appNode._vueApp = app.mount(appNode);
  }
}

// 页面加载完成后挂载
document.addEventListener('DOMContentLoaded', mountApp);

if (module.hot) {
  module.hot.accept('./4D20M.vue', () => {
    mountApp();
  });
}
</script>

<style lang="scss" scoped></style>